var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resources-index',{attrs:{"resources":_vm.resources,"type":"course","plural":"courses"}})}
var staticRenderFns = []

export { render, staticRenderFns }